import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { onMounted, ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { ErrorBag } from '@/core/common';
import { CustomerInvoiceAddress } from '@/modules/customer/Customer';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppInput from '@/core/components/form/AppInput.vue';

interface CustomerFormInvoiceAddressProps {
	invoiceAddress: CustomerInvoiceAddress;
	errors: ErrorBag;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerFormInvoiceAddress',
  props: {
    invoiceAddress: {},
    errors: {}
  },
  emits: [
	'update:invoiceAddress',
],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();
const props = __props;
const emit = __emit;

const data = ref<CustomerInvoiceAddress>();

onMounted(() => data.value = Object.assign({}, props.invoiceAddress));

watch(() => data.value, (value) => {
	emit('update:invoiceAddress', value);
}, {
	deep: true,
});

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (data.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[4] || (_cache[4] = [
          _createTextVNode("Fakturering", -1)
        ]))])), [
          [_directive_translate]
        ]),
        _createVNode(AppFormGroup, {
          id: "customer_invoice_address",
          errors: __props.errors.address,
          label: _unref($gettext)('Adress')
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              id: "customer_invoice_address",
              modelValue: data.value.address,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.address) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["errors", "label"]),
        _createVNode(AppFormGroup, {
          id: "customer_invoice_zipcode",
          errors: __props.errors.zipcode,
          label: _unref($gettext)('Postnummer')
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              id: "customer_invoice_zipcode",
              modelValue: data.value.zipcode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.zipcode) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["errors", "label"]),
        _createVNode(AppFormGroup, {
          id: "customer_invoice_city",
          errors: __props.errors.city,
          label: _unref($gettext)('Postort')
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              id: "customer_invoice_city",
              modelValue: data.value.city,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.city) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["errors", "label"]),
        _createVNode(AppFormGroup, {
          id: "customer_invoice_email",
          errors: __props.errors.email,
          label: _unref($gettext)('E-postadress')
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              type: "email",
              id: "customer_invoice_email",
              modelValue: data.value.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.email) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["errors", "label"])
      ]))
    : _createCommentVNode("", true)
}
}

})